export const openLinkInNewTab = (url: string, target = '_blank') => {
  setTimeout(() => window.open(url, target), 0);
};
